import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { mixpanel, constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import { Image } from 'components/_new/ui'
import ProductNotes from 'components/product/ProductNotes/ProductNotes'
import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'
import GiftSetPrice from 'pages/giftSets/components/GiftSetPrice/GiftSetPrice'

import GiftSetsCarousel from './GiftSetsCarousel/GiftSetsCarousel'

import messages from './messages'
import s from './GiftSetQuickViewModal.scss'


class GiftSetQuickViewModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.GiftSetQuickView,
  }

  handleClose = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  addToCart = () => {
    const { giftSet } = this.props

    mixpanel.track(constants.analyticsEvents.giftsetAddToCart, {
      name: giftSet.name,
    })

    actions.models.cart.addItem({ ...giftSet, id: giftSet.tradingItemId })
  }

  render() {
    const {
      name: modalName, isFetching,
      giftSet: { description, items, img, name, shortDescription, priceWithDiscount, price, inStock, includesTextVisible },
    } = this.props

    return (
      <Modal
        className={s.giftSetQuickViewModal}
        name={modalName}
        id={modalName}
        onClose={this.handleClose}
      >
        <div className={s.info}>
          <div className={s.title}>{name}</div>
          <div className={s.shortDescription}>{shortDescription}</div>
          <div className={s.imageBlock}>
            <Image className={s.image} src={img} w={300} x2 />
          </div>
          <p className={s.description}>{description}</p>
        </div>

        <div className={s.items}>
          <GiftSetsCarousel>
            {
              items.map(({ brand, description, notes, shortDescription, name, img, id }) => (
                <div key={id}>
                  <div className={s.brand}>{brand}</div>
                  <div className={s.name}>{name}</div>
                  <div className={s.shortDescription}>{shortDescription}</div>

                  <div className={s.imagesBlock}>
                    <div className={s.itemImage}>
                      <Image className={s.image} src={img} w={100} x2 />
                    </div>
                    <div className={s.notes}>
                      <ProductNotes noteClassName={s.note} items={notes} />
                    </div>
                  </div>

                  <div className={s.itemDescription} dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              ))
            }
          </GiftSetsCarousel>
        </div>

        <div className={s.price}>
          <GiftSetPrice price={price} priceWithDiscount={priceWithDiscount} />
        </div>
        {
          includesTextVisible && (
            <FormattedMessage className={s.includesText} tag="p" {...messages.includesOneMonth} />
          )
        }
        {
          !inStock && (
            <FormattedMessage className={s.outOfStock} tag="p" {...messages.outOfStock} />
          )
        }

        <div className={s.actions}>
          <Button
            title={messages.addToCart}
            disabled={!inStock}
            loading={isFetching}
            onClick={this.addToCart}
            fullWidth
            brand
            lg
          />
        </div>
        <FormattedMessage className={s.textInfo} tag="p" {...messages.textInfo} />
      </Modal>
    )
  }
}


export default connect({
  giftSet: 'models.giftSet.data',
  isFetching: 'models.cart.isFetching',
})(GiftSetQuickViewModal)
